import { type PropsWithChildren } from 'react'
import { Box } from '../../primitives/Box'
import { spacing } from '../../theme'

type Props = PropsWithChildren<{
  /**
   * When you want the element to be part of your setup, for example a checkbox for its functionality
   * but not showing it visually (in that case show the `ListItemSelectedIcon` as `secondaryIcon` on `ListItem` to visually support it). In most other cases you will not render the `ListItemIcon` at all.
   */
  isHidden?: boolean
}>

export const ListItemSelect = ({ children, isHidden }: Props) => (
  <Box
    sx={{
      display: 'inline-flex',
      lineHeight: 0,
      alignSelf: 'flex-start',
      flexShrink: 0,
      color: 'inherit',

      // FIXME: at moment could not use MuiFormControlLabel, since also used in Switch component
      '.MuiFormControlLabel-root': {
        marginLeft: 0,
      },

      '.DhlListItem-rounded > &': {
        borderRadius: ({ misc }) => misc.borderRadius(2),
      },

      ...(isHidden
        ? {
            width: 0,
            height: 0,
            overflow: 'hidden',
            padding: 0,
            minWidth: 0,
          }
        : { minWidth: spacing(3), pr: spacing(2.75) }),

      ':focus-within': {
        '&::after': {
          content: '""',
          position: 'absolute',
          left: 0,
          top: 0,
          right: 0,
          bottom: 0,
          borderRadius: 'inherit',
          border: ({ misc }) => misc.borderStyle('pure.dark', 2),
        },
      },
    }}
  >
    {children}
  </Box>
)
